import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';
import type { UserDataType } from '../../types/UserType';
import type { PhotoCardType } from '../../types/PhotoCardType';

interface ReportedPhotoCardsQueryProps {
  user: UserDataType | null;
  onlyPending: boolean;
  artistId: string;
}

interface ReportedPhotoCardsResponse {
  photoCards: PhotoCardType[];
}

export default function useReportedPhotoCardsQuery({
  user,
  onlyPending = true,
  artistId
}: ReportedPhotoCardsQueryProps) {
  const queryParams = new URLSearchParams();
  if (artistId) {
    queryParams.append('artist_id', artistId);
  }

  if (onlyPending) {
    queryParams.append('only_pending', onlyPending.toString());
  }

  return useQuery<ReportedPhotoCardsResponse, Error, PhotoCardType[]>(
    ['reportedPhotoCards', onlyPending, artistId],
    () => queryGet(`/api/v1/photo_cards/reported?${queryParams.toString()}`),
    {
      select: (data) => data.photoCards,
      enabled: !isEmpty(user?.baseUserProfile)
    }
  );
}
